import React from 'react';
export function About() {
  return <section className="py-16 md:py-20 border-b border-zinc-800" data-id="element-22">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-23">
        <h2 className="text-2xl md:text-3xl font-light mb-8 md:mb-10" data-id="element-24">
          Over mij
        </h2>
        <div className="grid md:grid-cols-5 gap-8 md:gap-10" data-id="element-25">
          <div className="md:col-span-3" data-id="element-26">
            <p className="text-base text-zinc-300 leading-relaxed mb-6" data-id="element-27">
              Ik ben Ahmet Uzun, een resultaatgerichte professional met ruime
              ervaring in beveiliging, retail en IT. Momenteel werk ik als
              coördinator beveiliging op Schiphol, waar ik dagelijks leidinggeef
              aan beveiligingsteams in een complexe en internationale omgeving.
            </p>
            <p className="text-base text-zinc-300 leading-relaxed" data-id="element-28">
              Eerder heb ik gewerkt als verkoopadviseur en systeembeheerder,
              waardoor ik sterk ben in zowel klantcontact als techniek. Ik sta
              bekend om mijn oog voor detail, stressbestendigheid en
              leiderschapskwaliteiten. Met mijn brede skillset, talenkennis
              (Nederlands, Engels, Turks) en ondernemersmentaliteit ben ik klaar
              voor een volgende stap als zelfstandige. Betrouwbaarheid,
              veiligheid en efficiëntie staan bij mij altijd voorop.
            </p>
          </div>
          <div className="md:col-span-2 bg-zinc-900 p-6 rounded-none border-l border-zinc-700 shadow-sm" data-id="element-29">
            <blockquote className="text-lg italic text-zinc-200 leading-relaxed" data-id="element-30">
              "Betrouwbaarheid, veiligheid en efficiëntie staan bij mij altijd
              voorop."
            </blockquote>
            <div className="mt-5 text-right text-zinc-400" data-id="element-31">— Ahmet Uzun</div>
          </div>
        </div>
      </div>
    </section>;
}